import { i as e, l as t } from "./chunk-lit-C22HS9_U.js";
import { t as n } from "./chunk-BaseElement-DsTFSTJC.js";
import { c as r, s as i, t as a } from "./chunk-decorate-DzD3B-3W.js";
import { t as o } from "./chunk-task-CimuyVWV.js";
import { t as s } from "./chunk-unsafe-html-Cz4T9pYU.js";
//#region src/styles/component-icon.css?inline
var c = "/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */\nsvg{width:100%;height:100%}", l = class extends n {
	static {
		this.styles = [t(c)];
	}
	constructor() {
		super(), this.iconAssetUrl = window.routes.icons, this._svgTask = new o(this, {
			task: async ([e], { signal: t }) => {
				let n = `${this.iconAssetUrl}/${e}.svg`, r = await fetch(n, { signal: t });
				if (!r.ok) throw Error(r.statusText);
				return await r.text();
			},
			args: () => [this.src]
		});
	}
	connectedCallback() {
		super.connectedCallback();
	}
	render() {
		return this._svgTask.render({
			pending: () => e`<span><!--loading icon--></span>`,
			complete: (t) => e`
          <div class="block h-full w-full">${s(t)}</div>
        `,
			error: () => e`<span><!--Error loading icon--></span>`
		}) || e`<span><!--Error loading icon--></span>`;
	}
};
a([i({ type: String })], l.prototype, "src", void 0), l = a([r("svg-icon")], l);
//#endregion
export { l as SvgIcon };
